module.exports = __webpack_public_path__ + "static/media/instapage101.8e59626d.png";